// @ts-nocheck
 
 
 
 
 
/* eslint-disable import/order */
 
 
 
 
 
 
 
import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { NotAuthorized } from 'app/components/not-authorized';
import { CardContainer } from 'app/components/shared/card-container';
import PassengersGroupsTable from './PassengersGroupsTable';
import { trimTrailingSlash, useTypedSelector } from 'helpers';
import { hasWriteAccessToFaresSubSystem } from 'selectors';
import AddPassengersGroup from './addPassengersGroup';
import EditPassengersGroup from './updatePassengersGroup';
import ViewPassengersGroup from './view-PassengersGroup';

const PassengersGroups: React.FC = () => {
  const match = useRouteMatch();
  const baseURL = trimTrailingSlash(match.url);

  const hasPassengersGroupsAddAccess = useTypedSelector(state =>
    hasWriteAccessToFaresSubSystem(state, 'PassengersGroups')
  );

  return (
    <CardContainer>
      <Switch>
        <Route path={`${baseURL}/new`}>
          {hasPassengersGroupsAddAccess ? <AddPassengersGroup/> : <NotAuthorized />}
        </Route>

        <Route path={`${baseURL}/:id/edit`}>
          {hasPassengersGroupsAddAccess ? <EditPassengersGroup/> : <NotAuthorized />}
        </Route>
        
        <Route path={`${baseURL}/:id`}>
          <ViewPassengersGroup/>
        </Route>
        
        <Route exact path={`${baseURL}`}>
          <PassengersGroupsTable/>
        </Route>
      </Switch>
    </CardContainer>
  );
};

export { PassengersGroups };
